/* eslint-disable no-nested-ternary */
import React, { useState, useContext, useEffect } from 'react';
import { DialogBox } from '@mummssoftware/common-ui';
import { FormattedMessage } from 'react-intl';
import { Context } from '../../context';
import { ProgressNotesContext } from '../Context/ProgressNotesContext';
import { UPDATE_COMPLETE_MAINT_STATUS } from '../Context/constants';
import defaults from '../../translations/en.json';

type RcopiaModalProps = {
  open?: boolean;
  onRcopiaClick?: () => void;
  payload?: mumms.RcopiaRes;
};

export const RcopiaModal = () => {
  const { rcopiaRes } = useContext(Context);
  const { dispatch } = useContext(ProgressNotesContext);

  const [open, setOpen] = useState<boolean>(false);
  const [payload, setPayload] = useState<mumms.RcopiaRes | null>(null);

  const handleRcopia = async () => {
    if (rcopiaRes) {
      if (rcopiaRes.embeddable === 'false' && !rcopiaRes.status) {
        // open RCOPIA in a window
        window.open(rcopiaRes.url as string);
        // Click on the check-mark when you are done adding medications
        (rcopiaRes as any).message = (
          <FormattedMessage {...defaults.rcopia.rcopiaDone} />
        );
        // no URL to open in embedded window
        rcopiaRes.url = null;
      }
      setPayload(rcopiaRes);
      setOpen(true);
    }
  };

  const handleClick = () => {
    dispatch({
      type: UPDATE_COMPLETE_MAINT_STATUS,
      payload: true,
    });
    setPayload(null);
    setOpen(false);
  };

  // if rcopiaRes
  useEffect(() => {
    if (rcopiaRes) {
      handleRcopia();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rcopiaRes]);

  let content: any = null;
  if (payload) {
    if (payload.url) {
      content = (
        <iframe
          src={payload.url}
          width="100%"
          height={0.75 * window.innerHeight}
          title="ClearScripts"
        ></iframe>
      );
    } else {
      content = <span>{payload.message}</span>;
    }
  }
  return payload ? (
    <DialogBox
      open={open}
      fullWidth={!!payload.url}
      maxWidth="xl"
      handleClick={handleClick}
      title="Rcopia"
    >
      {content}
    </DialogBox>
  ) : (
    <></>
  );
};
